import styled from '@emotion/styled'
import { Box, CssBaseline, Paper } from '@mui/material'
import React from 'react'
import { Outlet } from 'react-router-dom'

import DaiLogo from '@/components/DaiLogo'
import GlobalStyle from '@/components/GlobalStyle'

const Root = styled.div`
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  display: flex;
  min-height: 100%;
  flex-direction: column;
  width: 100%;
`

const ContentContainer = styled.div`
  width: 100%;
  max-width: 1040p;
`

const PricingLayout: React.FC<{
  children?: React.ReactNode
}> = ({ children }) => {
  return (
    <Root>
      <CssBaseline />
      <GlobalStyle />
      <ContentContainer>
        <Box
          sx={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            p: 6,
            gap: 6,
          }}
        >
          <DaiLogo />
          <Paper sx={{ padding: 6, width: '100%' }}>
            {children}
            <Outlet />
          </Paper>
        </Box>
      </ContentContainer>
    </Root>
  )
}

export default PricingLayout
